import React from "react";

export default function Home()
{
    return (
        <div className="row h-auto bg-secondary rounded align-items-center justify-content-center mx-0">
            <div className="col-md-6 text-center">
              <h3>This is blank page</h3>
            </div>
          </div>
    );
}